export default __webpack_public_path__ + "static/char-38-anr-78a0a593ec02bdfe28ce17ec7eea190d.webp";